import { render, staticRenderFns } from "./BranchTransactionDetail.vue?vue&type=template&id=5ae31277&"
import script from "./BranchTransactionDetail.vue?vue&type=script&lang=js&"
export * from "./BranchTransactionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports